export enum Role {
  ADMIN = 'Administrador',
  SUPERVISOR = 'Supervisor',
  OPERADOR = 'Operador',
}

export interface User {
  id: string;
  name: string;
  role: Role;
  email?: string;
  avatar?: string;
}

export interface Area {
  id: string;
  name: string;
  description?: string;
}

export enum MeterType {
  ELECTRICITY = 'Energía Eléctrica',
  WATER = 'Agua',
  CO2 = 'CO2',
  VAPOR = 'Vapor',
}

export enum MeterUnit {
  KWH = 'kWh',
  M3 = 'm³',
  TN = 'TN',
}

export interface Meter {
  id: string;
  name: string;
  type: MeterType;
  unit: MeterUnit;
  area: string; // Will reference Area.name or Area.id going forward
}

export interface StopRecord {
  id: string;
  meterId: string;
  startTime: number; // timestamp
  endTime?: number; // timestamp
  startValue: number;
  endValue?: number;
  reason: string;
  supervisorName?: string; // Nuevo campo, will be populated via User selection
  startPhoto?: string; // base64 string
  endPhoto?: string; // base64 string
  isManualStart: boolean;
  isManualEnd?: boolean;
}

export interface ProductionRecord {
  id?: string;
  date: string; // YYYY-MM-DD
  lineId: 'L1' | 'L3';
  projectedVolumeHl: number;
  plannedEvents: string[];
  realVolumeHl: number;
  realEvents: string[];
}

export interface ServiceCutoff {
  id?: string;
  date: string; // YYYY-MM-DD
  lineId: 'L1' | 'L3' | 'Elaboración';
  serviceType: 'electricity' | 'water' | 'steam' | 'co2';
  
  // Planificado
  plannedStartTime: string; // HH:MM
  plannedEndTime: string;   // HH:MM
  cutoffReason?: string;    // CIP, Mantenimiento, Cambio Formato, etc.
  
  // Real
  isConfirmed: boolean;
  actualStartTime?: string;
  actualEndTime?: string;
  operatorComment?: string;
  confirmedBy?: string;
  confirmedAt?: string;
}
